module.exports = __webpack_public_path__ + "img/icon-telegram.cf30b85d.svg";